<template>
    <div class="md-layout" v-if="screenVisible">
        <!-------- PAGE -------->
        <!-- TOOLBAR -->
        <md-toolbar md-elevation="1" v-if="simulation.clone">
            <h3 class="md-title" style="flex: 1">
                Você esta no modo edição!
            </h3>
            <md-button
                class="md-primary mr-1"
                @click="cancelUpdates(simulation.id)"
            >
                Cancelar Alterações
            </md-button>
            <md-button
                class="md-primary"
                @click="$refs.confirmModal.confirmModalOpen()"
            >
                Salvar e Gerar nova Simulação
            </md-button>
        </md-toolbar>
        <!-- SIMULATION -->
        <simulation-header
            :simulationLoading="simulationLoading"
            :simulation="simulation"
        ></simulation-header>
        <!-- PRODUCT -->
        <product-header
            :productLoading="productLoading"
            :product="product"
        ></product-header>
        <!-- FILTER -->
        <param-filter
            :baseStore="baseStore"
            parameterTypeTitle="loja"
            :simulation="simulation"
            :filterCluster="true"
        ></param-filter>
        <!-- TABLE -->
        <param-table
            :baseStore="baseStore"
            parameterType="branch"
            parameterTypeTitle="loja"
            :parameters="branchparameters"
            :simulation="simulation"
            :editModalOpen="editModalOpen"
            :actionModalOpen="actionModalOpen"
            :similarProductModalOpen="similarProductModalOpen"
        ></param-table>

        <!-------- MODALS -------->
        <!-- EDIT -->
        <edit-modal
            ref="editModal"
            :baseStore="baseStore"
            parameterType="branch"
            :simulation="simulation"
        ></edit-modal>
        <!-- ACTIONS -->
        <actions-modal
            ref="actionsModal"
            :baseStore="baseStore"
            parameterType="branch"
            :parameters="branchparameters.results"
            :simulation="simulation"
        ></actions-modal>
        <!-- CONFIRM -->
        <confirm-modal
            ref="confirmModal"
            :simulation="simulation"
        ></confirm-modal>
        <!-- SIMILAR PRODUCT -->
        <similar-product-modal
            ref="similarProductModal"
            :baseStore="baseStore"
            :simulation="simulation"
        ></similar-product-modal>
    </div>
    <div v-else>
        <div v-if="me">
            Você não pode acessar essa página!
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Utils from '@/utils'

import ProductHeader from '@/components/Parameters/ProductHeader'
import SimulationHeader from '@/components/Parameters/SimulationHeader'
import ParamFilter from '@/components/Parameters/Filter'
import ParamTable from '@/components/Parameters/ParamTable'
import ActionsModal from '@/components/Parameters/Modals/ActionsModal'
import ConfirmModal from '@/components/Parameters/Modals/ConfirmModal'
import EditModal from '@/components/Parameters/Modals/EditModal'
import SimilarProductModal from '@/components/Parameters/Modals/SimilarProductModal'

const model = 'branchcomponent'

export default {
    props: ['simulationId'],
    components: {
        ProductHeader,
        SimulationHeader,
        ParamTable,
        ActionsModal,
        ConfirmModal,
        EditModal,
        SimilarProductModal,
        ParamFilter
    },
    async created() {
        await this.readSimulation(this.simulationId)
        this.readProduct(this.simulation.product)
        this.readBranchParameter({
            simulation: this.simulation.clone
                ? this.simulation.clone
                : this.simulation.id
        })
    },
    mounted() {
        this.editModalOpen = this.$refs.editModal.editModalOpen
        this.actionModalOpen = this.$refs.actionsModal.actionModalOpen
        this.similarProductModalOpen = this.$refs.similarProductModal.similarProductModalOpen
    },
    computed: {
        ...mapState({
            branchparameters: state => state[model].page,
            simulation: state => state['simulations'].current,
            simulationLoading: state => state['simulations'].currentLoading,
            product: state => state['products'].current,
            me: state => state['auth'].me
        }),

        screenVisible() {
            if (this.me)
                return (
                    this.me.permissions.indexOf(
                        'simulations.view_branchcomponent'
                    ) > -1
                )
            return false
        }
    },
    data() {
        return {
            baseStore: model,
            productLoading: true,

            // method references
            editModalOpen: null,
            actionModalOpen: null,
            similarProductModalOpen: null
        }
    },
    methods: {
        ...mapActions(model, {
            readBranchParameter: 'read',
            updateBranchParameters: 'update',
            removeBranchParameters: 'remove'
        }),
        ...mapActions('simulations', {
            readSimulation: 'readById',
            removeClone: 'removeClone',
            createClone: 'createClone',
            executeSimulation: 'execute'
        }),
        ...mapActions('products', {
            _readProduct: 'readById'
        }),

        formatNumber: (number, type) => Utils.formatNumber(number, type),

        async readProduct(productId) {
            this.productLoading = true
            await this._readProduct(productId)
            this.productLoading = false
        },

        cancelUpdates() {
            this.removeClone(this.simulation.id)
            this.readBranchParameter({ simulation: this.simulation.id })
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-panel {
    font-size: 1.5em;
    cursor: pointer;
}

.md-toolbar {
    background-color: #12578f !important;
    position: fixed !important;
    top: 50px;
    left: 280px;
    right: 20px;
    width: auto;
}
.sidebar-mini .md-toolbar {
    margin-left: 20px;
    right: 20px;
    left: 80px;
}
</style>
